import { styled } from "@monolith-forensics/monolith-ui";
import { LucideIcon, SigmaIcon } from "lucide-react";

const StyledContainer = styled.div`
  display: flex;
  align-content: center;
  align-items: center;
  margin-left: 10px;
  cursor: pointer;
  color: ${(props) => props.theme.palette.text.secondary};
  &:hover {
    color: ${(props) => props.theme.palette.text.primary};
  }
`;

export const ItemTotalBadge: React.FC<{
  // A preformatted string (e.g. a currency total) renders as-is
  total: number | string;
  Icon?: LucideIcon;
  title?: string;
  style?: React.CSSProperties;
}> = ({ total, Icon = SigmaIcon, title = "Total Items", style = {} }) => {
  return (
    <StyledContainer title={title} style={style}>
      <Icon
        style={{
          fontSize: 14,
          marginRight: 5,
        }}
        size={14}
      />
      <div
        style={{
          fontSize: 12,
        }}
      >
        {total || 0}
      </div>
    </StyledContainer>
  );
};
